define([
	'components/utilities/utilities',
	'libs/hoverIntent'
], function (utils, hoverIntent) {
	'use strict';

	/**
	 * Megadrop
	 * Functions for the megadrop.
	 * @version 2.0.0
	 * @exports megadrop
	 */
	var megadrop = {

		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			if (!Modernizr.touchevents) {
				this._initHoverIntent();
			} else {
				this._initTouchHover();
			}
			this._initKeyboardNavigation();
		},


		/**
		 * Add megadrop hover function with the hoverIntent plugin.
		 * @private
		 */
		_initHoverIntent: function () {
			utils.forEachElement('.has-megadrop', function (el) {
				hoverIntent(el,
					function () {
						utils.addClass(this, 'megadrop-active');
					}, function () {
						utils.removeClass(this, 'megadrop-active');
					}
				).options({
					timeout: 300,
					interval: 300
				});
			});

			utils.removeClass(document.documentElement, 'megadrop-uninitiated'); // Removal of this class will disable megadrop display through css hovering.
		},


		/**
		 * Fixes so hover works on touch devices.
		 * @private
		 */
		_initTouchHover: function () {
			utils.forEachElement('.has-megadrop', function (el) {
				utils.addEventListener(el, 'click', function (event) {
					if (!utils.hasClass(el, 'megadrop-active') || (utils.hasClass(el, 'megadrop-active') && event.target.tagName !== 'A')) {
						if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
					}

					utils.forEachElement('.has-megadrop', function (el) {
						utils.removeClass(el, 'megadrop-active');
					});
					utils.addClass(this, 'megadrop-active');
				});
			});

			utils.removeClass(document.documentElement, 'megadrop-uninitiated'); // Removal of this class will disable megadrop display through css hovering.
		},


		/**
		 * Add keyboard tab navigation to megadrop.
		 * @private
		 */
		_initKeyboardNavigation: function () {
			utils.forEachElement('.has-megadrop', function (el) {
				utils.addEventListener(el, 'keydown', function (event) {
					if (event.keyCode === 13) {
						if (!utils.hasClass(this, 'megadrop-active')) {
							if (event.preventDefault) { event.preventDefault(); } else { event.returnValue = false; }
							utils.addClass(this, 'megadrop-active');
						}
					}
				});

				utils.addEventListener(el, 'focus', function () {
					if (this.getAttribute('data-focusOutTimer') !== undefined) {
						clearTimeout(this.getAttribute('data-focusOutTimer'));
					}
				});

				utils.addEventListener(el, 'blur', function () {
					var link = this;

					this.setAttribute('data-focusOutTimer', setTimeout(function () {
						utils.removeClass(link, 'megadrop-active');
					}, 50));
				});
			});
		}
	};


	return megadrop;
});